import { createContext } from 'react';

const GlobalLoadingModalContext = createContext({ loading: false });
export default GlobalLoadingModalContext;
